
import { useState, useEffect } from 'react';
import { Customer } from '@/lib/supabase/customers/types';
import { useCustomerFormState } from './useCustomerFormState';

export const useCustomerFormData = (customer: Customer | null) => {
  const {
    name, setName,
    email, setEmail,
    phone, setPhone,
    selectedCountryCode, setSelectedCountryCode,
    country, setCountry,
    region, setRegion,
    municipality, setMunicipality,
    address, setAddress,
    errors, setErrors,
    validateForm
  } = useCustomerFormState(customer);

  // Update form fields when customer data is loaded
  useEffect(() => {
    if (customer) {
      setName(customer.name || '');
      setEmail(customer.email || '');
      setPhone(customer.phone || '');
      setCountry(customer.country || '');
      setRegion(customer.region || '');
      setMunicipality(customer.municipality || '');
      setAddress(customer.address || '');
    }
  }, [customer]);

  // Prepare customer data for saving
  const prepareCustomerData = (): Partial<Customer> => {
    return {
      name,
      email: email || null,
      phone: phone || null,
      country: country || null,
      region: region || null,
      municipality: municipality || null,
      address: address || null,
    };
  };

  return {
    // Form field values
    name, setName,
    email, setEmail,
    phone, setPhone,
    selectedCountryCode, setSelectedCountryCode,
    country, setCountry,
    region, setRegion,
    municipality, setMunicipality,
    address, setAddress,
    
    // Validation 
    errors,
    setErrors,
    validateForm,
    
    // Helper methods
    prepareCustomerData,
  };
};
